// extracted by mini-css-extract-plugin
module.exports = {"iconSearch":"SearchBar_iconSearch__vugEa","input":"SearchBar_input__Wepfb"};